// src/lib/pages/backoffice/SpecialCollections/SpecialCollectionDetails/state/actions.js

import { specialCollectionsApi } from "@api/specialCollections";
import { searchReady } from "@api/utils";
import { BackOfficeRoutes } from "@routes/urls";
import {
  sendErrorNotification,
  sendSuccessNotification,
} from "@components/Notifications";
import { goTo } from "@history";

export const IS_LOADING = "fetchSpecialCollectionDetails/IS_LOADING";
export const SUCCESS = "fetchSpecialCollectionDetails/SUCCESS";
export const HAS_ERROR = "fetchSpecialCollectionDetails/HAS_ERROR";
export const DELETE_IS_LOADING = "deleteSpecialCollection/DELETE_IS_LOADING";
export const DELETE_SUCCESS = "deleteSpecialCollection/DELETE_SUCCESS";
export const DELETE_HAS_ERROR = "deleteSpecialCollection/DELETE_HAS_ERROR";

export const fetchSpecialCollectionDetails = (specialCollectionPid) => {
  return async (dispatch) => {
    dispatch({
      type: IS_LOADING,
    });

    try {
      const response = await specialCollectionsApi.get(specialCollectionPid);
      dispatch({
        type: SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: HAS_ERROR,
        payload: error,
      });
      dispatch(sendErrorNotification(error));
    }
  };
};

export const deleteSpecialCollection = (specialCollectionPid) => {
  return async (dispatch) => {
    dispatch({
      type: DELETE_IS_LOADING,
    });

    try {
      await specialCollectionsApi.delete(specialCollectionPid);
      await searchReady();
      dispatch({
        type: DELETE_SUCCESS,
        payload: { specialCollectionPid: specialCollectionPid },
      });
      dispatch(
        sendSuccessNotification(
          "Success!",
          `The special collection ${specialCollectionPid} has been deleted.`
        )
      );
      goTo(BackOfficeRoutes.specialColList);
    } catch (error) {
      dispatch({
        type: DELETE_HAS_ERROR,
        payload: error,
      });
      dispatch(sendErrorNotification(error));
    }
  };
};
